module.exports = __webpack_public_path__ + "static/media/icon_insurance.cb451f7f.svg";